module.exports = __webpack_public_path__ + "img/concept_top_logo.53ecd7e3.png";